"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketInventoryConfigurationInput_1 = require("./DeleteBucketInventoryConfigurationInput");
var DeleteBucketInventoryConfigurationOutput_1 = require("./DeleteBucketInventoryConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucketInventoryConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucketInventoryConfiguration",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}?inventory"
    },
    input: {
        shape: DeleteBucketInventoryConfigurationInput_1.DeleteBucketInventoryConfigurationInput
    },
    output: {
        shape: DeleteBucketInventoryConfigurationOutput_1.DeleteBucketInventoryConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucketInventoryConfiguration.js.map